export default __webpack_public_path__ + "static/media/Northernlights.86ac0ada.webp";